var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarHalfFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1777_83362)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M.5.3999h18v18H.5z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1777_83362)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00444D",
    d: "M17.4574 6.2092l-5.1006-.7413L10.0766.8454A.6393.6393 0 0 0 9.7853.554C9.468.3974 9.0822.528 8.9235.8454L6.6434 5.4679l-5.1007.7413a.6416.6416 0 0 0-.3676.1869.6439.6439 0 0 0 .012.91l3.6904 3.598-.8719 5.0806a.6415.6415 0 0 0 .2553.6287.6414.6414 0 0 0 .6769.0483L9.5 14.263l4.5623 2.3987a.6382.6382 0 0 0 .4078.0643c.3496-.0603.5846-.3918.5244-.7413l-.8719-5.0806 3.6904-3.598a.642.642 0 0 0 .1868-.3676c.0543-.3516-.1908-.677-.5424-.7293zm-4.8877 4.1886l.7252 4.2248L9.5 12.6298l-3.7948 1.9948.7252-4.2247-3.0696-2.9934 4.2428-.6167L9.5 2.9468l1.8965 3.843 4.2428.6168-3.0696 2.9912z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00444D",
    d: "M9.5 13.3999v-11.5l-2.5 4.5-4.5 1 3.5 3-1 5 4.5-2z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1777_83362"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z",
    transform: "translate(.5 .3999)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1777_83362"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z",
    transform: "translate(.5 .3999)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarHalfFilled);
export default __webpack_public_path__ + "static/media/star-half-filled.54d41265.svg";
export { ForwardRef as ReactComponent };